export default [
  {
    path: '/multitask',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('./containers/MultitaskContainer'),
        children: [],
      },
    ],
  },
]
